import { RestService } from "@abp/ng.core";
import { Injectable } from "@angular/core";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { Observable } from "rxjs";
import { NotificationUser } from "./notification-user";
import { Common } from "src/app/model/common";

@Injectable({
    providedIn: 'root',
})
export class NotificationUserService {
    @BlockUI() blockUI: NgBlockUI; 
    apiName = 'warr';
    constructor(private restService: RestService) {
    }

    /**
   * GetSerial
   */
    async getNotificationByUser(input: NotificationUser.NotificationFilterDto): Promise<NotificationUser.NotificationListResourceDTO> {
        return (await new Observable((subscribe) => {
            this.restService
                .request<any, NotificationUser.NotificationListResourceDTO>(
                    {
                        method: 'GET',
                        url: `/api/app/notifications/get-list-update`,
                        params: input
                    },
                    {
                        apiName: this.apiName,
                    }
                )
                .subscribe((response) => {
                    subscribe.next(response);
                    subscribe.complete();
                }, (error) => {
                    this.blockUI.stop();
                    const res = { resultStatus: 'Error', errors:[{errorMessage: error?.name }]};
                    subscribe.next(res);
                    subscribe.complete();
                });
        }).toPromise()) as NotificationUser.NotificationListResourceDTO;
    }

    async updateReadAllNotification(): Promise<Common.WarrResponseDto<boolean>> {
        return (await new Observable((subscribe) => {
            this.restService
                .request<any, Common.WarrResponseDto<boolean>>(
                    {
                        method: 'PUT',
                        url: `/api/app/notifications/read-all`,
                    },
                    {
                        apiName: this.apiName,
                    }
                )
                .subscribe((response) => {
                    subscribe.next(response);
                    subscribe.complete();
                }, (error) => {
                    this.blockUI.stop();
                    const res = { resultStatus: 'Error', errors:[{errorMessage: error?.name }]};
                    subscribe.next(res);
                    subscribe.complete();
                });
        }).toPromise()) as Common.WarrResponseDto<boolean>;
    }
}